/**
 * Configuración global de actions
 */
export const DO_ROUTE = "DO_ROUTE";
export const DO_ROUTE_PUSH = "DO_ROUTE_PUSH";
export const DO_IS_LOADING = "DO_IS_LOADING";
export const DO_REQUEST_API = "DO_REQUEST_API";
export const DO_LANDING = "DO_LANDING";
export const DO_PASO1 = "DO_PASO1";

export const DO_PASO2 = "DO_PASO2";
export const DO_PASO2_SUCCESS = "DO_PASO2_SUCCESS";
export const DO_PASO_ERROR = "DO_PASO_ERROR";
export const DO_GRACIAS = "DO_GRACIAS";
export const DO_MENSAJE = "DO_MENSAJE";
export const DO_MOCK = "DO_MOCK";

export const DO_DATOS_PERSONALES = "DO_DATOS_PERSONALES";
export const DO_DATOS_PERSONALES_SUCCESS = "DO_DATOS_PERSONALES_SUCCESS";
export const DO_GET_SUCURSALES = "DO_GET_SUCURSALES";
export const DO_GET_SUCURSALES_SUCCESS = "DO_GET_SUCURSALES_SUCCESS";
export const DO_DATOS_SUCURSAL = "DO_DATOS_SUCURSAL";
export const DO_DATOS_SUCURSAL_SUCCESS = "DO_DATOS_SUCURSAL_SUCCESS";
export const DO_TIPOS_TRAMITE = "DO_TIPOS_TRAMITE";
export const DO_FECHA_HORA = "DO_FECHA_HORA";
export const DO_FECHA_HORA_SUCCESS = "DO_FECHA_HORA_SUCCESS";
export const DO_TIPOS_TRAMITE_SUCCESS = "DO_TIPOS_TRAMITE_SUCCESS";
export const DO_FECHA_TURNO = "DO_FECHA_TURNO";
export const DO_CONFIRMACION = "DO_CONFIRMACION";
export const DO_CONFIRMACION_SUCCESS = "DO_CONFIRMACION_SUCCESS";
